module.exports = __webpack_public_path__ + "img/support_nl.58dae10d.jpg";